import { render, staticRenderFns } from "./form-request.vue?vue&type=template&id=66be4fd6&scoped=true"
import script from "./form-request.vue?vue&type=script&lang=js"
export * from "./form-request.vue?vue&type=script&lang=js"
import style0 from "./form-request.vue?vue&type=style&index=0&id=66be4fd6&prod&lang=css"
import style1 from "./form-request.vue?vue&type=style&index=1&id=66be4fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be4fd6",
  null
  
)

export default component.exports